  export const TEXTS = {
    ru: {
      titlezzz: 'Выбор языка',
      btn: 'русский ',
    },
    en: {
        titlezzz: 'Choose language',
        btn: 'english',
    },
    de: {
        titlezzz: 'Sprache wählen',
        btn: 'deutsch',
    },
  };